<template>
  <transition name="fade">
    <div
      v-if="isOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      @click.self="cancel"
    >
      <div class="bg-white rounded-xl shadow-lg max-w-md w-full p-6 mx-4" role="dialog" aria-modal="true">
        <h3 class="text-lg font-semibold text-gray-800 mb-4">{{ title }}</h3>

        <!-- Der Slot erlaubt reichere Inhalte (z. B. einen Warnblock), ohne die
             bestehenden Aufrufer anzufassen: ohne Slot bleibt es die Meldung. -->
        <div class="text-gray-600 mb-6 whitespace-pre-line">
          <slot>{{ message }}</slot>
        </div>

        <div class="flex flex-wrap justify-between gap-2 mt-6">
            <!-- Cancel button first (left) -->
            <BaseButton ref="cancelBtn" @click="cancel" variant="cancel">
                {{ cancelLabel }}
            </BaseButton>

            <div class="flex flex-wrap gap-2">
              <!-- Dritter Weg, nur wenn ein Label gesetzt ist. Gebraucht z. B.
                   bei "Freigeben" mit ungespeicherten Aenderungen: speichern
                   ODER verwerfen ODER abbrechen. -->
              <BaseButton v-if="extraLabel" @click="extra" :variant="extraVariant">
                {{ extraLabel }}
              </BaseButton>

              <BaseButton ref="confirmBtn" @click="confirm" :variant="confirmVariant">
                {{ confirmLabel }}
              </BaseButton>
            </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import BaseButton from "./BaseButton.vue";

export default {
  components: { BaseButton },
  props: {
    isOpen: { type: Boolean, required: true },
    title: { type: String, default: "Confirm Action" },
    message: { type: String, default: "Are you sure?" },
    confirmLabel: { type: String, default: "Delete" },
    // Default 'delete' haelt alle neun Bestandsaufrufe unveraendert.
    confirmVariant: { type: String, default: "delete" },
    cancelLabel: { type: String, default: "Cancel" },
    extraLabel: { type: String, default: "" },
    extraVariant: { type: String, default: "neutral" },
  },
  emits: ["confirm", "cancel", "extra"],
  watch: {
    isOpen(offen) {
      // ACHTUNG: der Listener haengt NUR solange der Dialog offen ist. Sonst
      // sammeln sich die Escape-Handler unsichtbarer Modale an window an.
      if (offen) {
        window.addEventListener("keydown", this.onKeydown);
        this.$nextTick(() => {
          const el = this.$refs.confirmBtn?.$el;
          if (el && typeof el.focus === "function") el.focus();
        });
      } else {
        window.removeEventListener("keydown", this.onKeydown);
      }
    },
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.onKeydown);
  },
  methods: {
    onKeydown(e) {
      if (e.key !== "Escape") return;
      e.preventDefault();
      e.stopPropagation();
      this.cancel();
    },
    confirm() {
      this.$emit("confirm");
    },
    cancel() {
      this.$emit("cancel");
    },
    extra() {
      this.$emit("extra");
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
